import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PagedResponse } from '../../../shared/contract/paged-response.contract';
import { getHttpParameters } from '../../../shared/utils/get-http-parameters';
import { GetUsersRequest } from '../contract/requests/get-users-request.contract';
import { SearchUsersRequest } from '../contract/requests/search-users-request.contract';
import { SearchUser } from '../contract/search-user.contract';

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  private url = environment.APP_USERROLE_SERVICE_BASE_URL + '/api/v1/users';

  constructor(private http: HttpClient) {}

  public getUsers({ page, size }: GetUsersRequest): Observable<PagedResponse<SearchUser>> {
    const httpParams = getHttpParameters({ page, size });

    return this.http.get<PagedResponse<SearchUser>>(this.url, {
      params: httpParams,
    });
  }

  public searchUsers({ page, size, terms }: SearchUsersRequest): Observable<PagedResponse<SearchUser>> {
    let params = getHttpParameters({ page, size });
    params = params.set('terms', terms ?? '');

    return this.http.get<PagedResponse<SearchUser>>(`${this.url}/search/all`, {
      params,
    });
  }

  public getUsersCrossOrganisation({ page, size }: SearchUsersRequest): Observable<PagedResponse<SearchUser>> {
    const httpParams = getHttpParameters({ page, size });

    return this.http.get<PagedResponse<SearchUser>>(`${this.url}/cross-organisation`, {
      params: httpParams,
    });
  }
}
